import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    code: 'REGLES',
    icon: 'bi bi-list-check',
    id: 1711,
    label: 'tmw.regles.menu-title',
    access: 'regles',
    moduleAccess: 'MDL_REGLES',
    subItems: [
      {
        code: 'REGLE',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/regle',
        id: -222,
        label: 'tmw.regle.menu-title',
        access: 'regles_List',
        moduleAccess: 'MDL_REGLES',
        parentId: 7109,
      },
      {
        code: 'REGLE_GROUPE',
        access: 'groupeRegles_List',
        moduleAccess: 'MDL_REGLES',
        icon: 'bi bi-diagram-3',
        link: '/backoffice/groupe-regle',
        id: 1223,
        label: 'tmw.groupeRegle.menu-groupe-title',
        parentId: 7109,
      },
    ],
  },
  {
    code: 'ADMIN',
    icon: 'bi bi-gear-fill',
    id: 17109,
    label: 'tmw.administration.menu-title',
    access: 'administrations',
    moduleAccess: 'MDL_ADMINISTRATION',
    subItems: [
      {
        code: 'ANNEXE',
        icon: 'bi bi-bell-fill',
        access: 'annexeContexts_List',
        moduleAccess: 'MDL_ADMINISTRATION',
        link: '/backoffice/annexe-context',
        id: -616,
        label: 'tmw.annex-config.menu-title',
        parentId: 17109,
      },
      {
        code: 'PLANIFICATION',
        link: '/backoffice/tache',
        id: 17160,
        access: 'planifications_List',
        moduleAccess: 'MDL_PLANIFICATION',
        label: 'tmw.planification.menu-title',
        parentId: 17109,
      },
      {
        code: 'NOTIFICATIONS',
        icon: 'bi bi-bell-fill',
        link: '/backoffice/notification-context',
        access: 'notificationContexts_List',
        moduleAccess: 'MDL_ADMINISTRATION',
        id: 17151,
        label: 'Notifications',
        parentId: 17109,
      },
      {
        code: 'EDITION',
        link: '/backoffice/edition',
        id: 17152,
        access: 'editions_List',
        moduleAccess: 'MDL_ADMINISTRATION',
        label: 'tmw.edition.menu-title',
        parentId: 17109,
      },
      {
        code: 'WORKFLOW',
        link: '/backoffice/workflow',
        id: 17154,
        access: 'workflow_List',
        moduleAccess: 'MDL_WORKFLOW',
        label: 'tmw.workflow.menu-title',
        parentId: 17109,
      },
    ],
  },
  {
    code: 'USERS',
    icon: 'bi bi-person-fill-gear',
    id: 17112,
    label: 'Gestion Utilisateurs',
    access: 'utilisateurs',
    moduleAccess: 'MDL_UTILISATEURS',
    subItems: [
      {
        code: 'UTILISATEUR',
        link: '/backoffice/utilisateur',
        id: 17157,
        access: 'utilisateurs_List',
        moduleAccess: 'MDL_UTILISATEURS',
        label: 'tmw.utilisateur.menu-title',
        parentId: 17112,
      },
      {
        code: 'ROLE',
        link: '/backoffice/role',
        id: 17158,
        access: 'roles_List',
        moduleAccess: 'MDL_UTILISATEURS',
        label: 'tmw.role.menu-title',
        parentId: 17112,
      },
      {
        code: 'AFFECTATION_MODULES',
        link: '/backoffice/habilitation',
        id: 17159,
        access: 'habilitations_List',
        moduleAccess: 'MDL_UTILISATEURS',
        label: 'tmw.affectationModules.menu-title',
        parentId: 17112,
      },
    ],
  },
  {
    code: 'REFERENTIELS',
    icon: 'bi bi-database-fill-gear',
    id: 17111,
    label: 'tmw.referentiels.menu-title',
    access: 'referentiels',
    moduleAccess: 'MDL_REFERENTIELS',
    subItems: [
      {
        code: 'REFERENTIEL',
        link: '/backoffice/referentiel',
        id: 17155,
        access: 'referentiels_List',
        moduleAccess: 'MDL_REFERENTIELS',
        label: 'tmw.referentiel.menu-title',
        parentId: 17111,
      },
      {
        code: 'REQUETE',
        link: '/backoffice/requete',
        id: 17156,
        access: 'contexts_List',
        moduleAccess: 'MDL_REFERENTIELS',
        label: 'tmw.requete.menu-title',
        parentId: 17111,
      },
    ],
  },
  {
    code: 'PARAMETRAGES',
    icon: 'bi bi-database-fill-gear',
    id: 18111,
    label: 'tmw.parametrages.menu-title',
    access: 'parametrages',
    moduleAccess: 'MDL_ADMINISTRATION',
    subItems: [
      {
        id: 18112,
        label: 'tmw.matriceDelegation.menu-title',
        link: '/backoffice/matrice-delegation',
        access: 'matriceDelegations_List',
        moduleAccess: 'MDL_ADMINISTRATION',
        parentId: 18111,
      },
    ],
  },
];

export const TEMPLATE_PAGES: MenuItem = {
  id: -999999,
  code: 'TEMPLATE_PAGES',
  label: 'Template Pages',
  isLayout: true,
};
